export default class Throttle {
    static throttle(function_to_throttle, wait = 100, options = { trailing: false }) {
        let lastCall = 0;
        let timeout = null;
        let lastArgs = null;

        return function throttled(...args) {
            const now = Date.now();
            const remaining = wait - (now - lastCall);

            if (remaining <= 0) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                lastCall = now;
                function_to_throttle.apply(this, args);
            } else if (options.trailing) {
                lastArgs = args;
                if (!timeout) {
                    timeout = setTimeout(() => {
                        lastCall = Date.now();
                        timeout = null;
                        function_to_throttle.apply(this, lastArgs);
                        lastArgs = null;
                    }, remaining);
                }
            }
        };
    }
}